import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=04e6d243&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=ts&"
export * from "./Index.vue?vue&type=script&lang=ts&"
import style0 from "./Index.vue?vue&type=style&index=0&id=04e6d243&lang=scss&scoped=true&"
import style1 from "./Index.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6d243",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\vNextBuildV3\\29\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('04e6d243', component.options)
    } else {
      api.reload('04e6d243', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=04e6d243&scoped=true&", function () {
      api.rerender('04e6d243', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueApp/views/TermsOfUse/Index.vue"
export default component.exports